import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Apicadastro } from '../axioscadastro';

export interface IListagemConta {
  idconta: number;
  nomebanco: string;
  agencia: string;
  numeroconta: string;
  status: boolean;
  titular: string;
  banco: string;
}
 
type TComTotalCount = {
    data: IListagemConta[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAllList = async (filter = '', id = ''): Promise<TComTotalCount | Error> => {
  try {
   
    const urlRelativa: string = id === '' ?  `/contabancarialist?limit=5&filter=${filter}` : `/contabancarialist/${id}`;

    const { data, headers } = await Apicadastro.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


export const ContaBancariaService = {
  getAllList,
};